module.exports = __webpack_public_path__ + "static/str-febee8cccacd7e864e47febdd14ecaa7.jpg";